import DrawRectangle from "mapbox-gl-draw-rectangle-mode";
import { FixedRectangleMode } from "./FixedRectangleMode";

export const rectangleMode = {
  draw_rectangle: DrawRectangle,
  draw_fixed_rectangle: FixedRectangleMode
};
